/**
 * Public (unauthenticated) marketing routes.
 *
 * Single source of truth for "is this a public page?" — used to keep the
 * institution-setup modal off marketing pages AND to scope web analytics to the
 * public site only (never the authenticated app). Keep in sync with the public
 * <Route> list in App.tsx.
 */
export const PUBLIC_PATHS = [
  '/', '/login', '/register', '/forgot-password', '/reset-password', '/verify-email',
  '/auth/callback', '/request-demo', '/pricing', '/contact', '/privacy', '/terms',
  '/support', '/docs', '/security', '/features', '/privacy-policy', '/terms-of-service',
  '/invites', '/partners', '/oauth', '/demo',
];

export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_PATHS.some(p =>
    p === '/' ? pathname === '/' : pathname === p || pathname.startsWith(p + '/')
  );
}
